import * as React from 'react';
import propz from 'propz';
import { Form, Formik } from 'formik';
import { SchoolEvent } from 'Src/models/event';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { ReportActions, ReportDescription, ReportRadioGroup, ReportSection } from '../ReportFormUi';
import '../../SchoolEventView.scss';

const OPTIONS = {
  IS_THIS_EVENT: 'isThisEvent',
  IS_FUTURE_EVENTS: 'isFutureEvents',
  IS_ALL_EVENTS: 'isAllEvents'
};

interface Props {
  event: SchoolEvent;
  activeSchoolId: string;
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

//report 068
export function PaperAttendanceRegisterEventReportForm(props: Props) {
  const requestInitial = {
    options: OPTIONS.IS_THIS_EVENT,
    isThisEvent: false,
    isFutureEvents: false,
    isAllEvents: false
  };

  return (
    <Formik
      onSubmit={values => {
        const valuesToTransfer = { ...values };
        propz.set(valuesToTransfer, [valuesToTransfer.options], true);
        delete valuesToTransfer.options;

        props.onSubmit(valuesToTransfer, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.PAPER_ATTENDANCE_REGISTER_EVENT);
      }}
      initialValues={requestInitial}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <ReportDescription>A printable paper register to mark student attendance.</ReportDescription>

          <ReportSection
            number={1}
            title="Register scope"
            hint="Choose which events should be included in the attendance register."
          >
            <ReportRadioGroup
              name="Attendance register scope"
              value={values.options}
              onChange={value => setFieldValue('options', value)}
              options={[
                {
                  value: OPTIONS.IS_THIS_EVENT,
                  label: 'This event only',
                  hint: 'Print a register for this event only.'
                },
                {
                  value: OPTIONS.IS_FUTURE_EVENTS,
                  label: 'This and subsequent events',
                  hint: 'Print registers for this event and later events in the club.'
                },
                {
                  value: OPTIONS.IS_ALL_EVENTS,
                  label: 'All events',
                  hint: 'Print registers for all events in the club, including past and future events.'
                }
              ]}
            />
          </ReportSection>

          <ReportActions onCancel={props.onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}
